import { render, staticRenderFns } from "./ReportTeaser.vue?vue&type=template&id=33c7470a"
import script from "./ReportTeaser.vue?vue&type=script&lang=js"
export * from "./ReportTeaser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports